var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.98 21.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.89,11.07H.75a.76.76,0,0,0-.75.77V12l7.82,6.2L15.64,12v-.15A.76.76,0,0,0,14.89,11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.44v7.74A.77.77,0,0,0,.75,22H14.89a.77.77,0,0,0,.75-.78V13.44l-7.82,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62,9.32a3.74,3.74,0,0,1,3.74-3.74H19V2.32A2.32,2.32,0,0,0,16.7,0H5.29A2.32,2.32,0,0,0,3,2.32V9.65H6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.66,7H10.36A2.32,2.32,0,0,0,8,9.32v.33h6.86a2.19,2.19,0,0,1,2.17,2.19V18h5.6A2.32,2.32,0,0,0,25,15.65V9.32A2.32,2.32,0,0,0,22.66,7Zm-.25,4.47a1,1,0,0,1-.95.95h-.93a1,1,0,0,1-1-.95v-.93a1,1,0,0,1,1-1h.93a1,1,0,0,1,.95,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.ed8acb72ff24138f5c56047132fc0478.svg";
export { ForwardRef as ReactComponent };